import { Component, Input } from '@angular/core';
import { ButtonComponent } from "../../../shared/button/button.component";

@Component({
  selector: 'app-update-required',
  standalone: true,
  imports: [
    ButtonComponent
  ],
  templateUrl: './update-required.component.html',
  styleUrl: './update-required.component.scss'
})
export class UpdateRequiredComponent {
  @Input() currentVersion: string = '0.0.0';
  @Input() latestVersion: string = '0.0.0';

  constructor() {

  }
  hardRefresh(): void {
    window.location.reload();
  }
}
